import { CohabitationDetailAnscNotificationsMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchCohabitationNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-cohabitation';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchCohabitationNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchCohabitationNotificationCivilStatusShared
        scope={IdAmbito.Mutazioni}
        items={CohabitationDetailAnscNotificationsMutationCrumbs()}
      />
    </Fragment>
  );
};

ResearchCohabitationNotificationCivilStatusPage.displayName =
  'Research Cohabitation Notifications Page component';

export default ResearchCohabitationNotificationCivilStatusPage;
